import React, { Component } from 'react';

class BasicForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      username: "",
      password: ""
    };
  }

  render() {
      return (
	<div>
	    <form onSubmit={ this.saveAndContinue }>

            <label>Username</label> 
            <input name="username" type="text" onChange={this.handleInputChange} />

	    <label>Password</label>
	    <input name="password" type="password" onChange={this.handleInputChange} />

	    <button type="submit">Submit</button>
	    <button className="usa-button-secondary" onClick={this.props.onBackToOptions}>Back to Options</button>
	    </form>
	</div>
      );
  }

  handleInputChange = (e) => {
    const target = e.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  saveAndContinue = (e) => {
    e.preventDefault();

    var data = {
      username: this.state.username,
      password: this.state.password
    };

    this.props.onLogin(data);
  }
}

export default BasicForm;



// WEBPACK FOOTER //
// ./src/BasicForm.jsx